const coxbazarDetails = [
    {
    id: 1,
    category: "coxbazar",
    name: "Light bright airy stylish apt and peaceful stay",
    capacity: "4 guests 2 bedrooms 2 beds  2 baths",
    shortDescription: "Wif Air Condition Kitchen",
    facility: "Cancellation flexibility available",
    stars: "4.9(20)",
    price: 34,
    totalPrice: "167 total",
    details: "Cox's Bazar is a city, fishing port, tourism center and district headquarters in southern Bangladesh. It is famous mostly for its long natural sandy beach and its...",
    photo: "https://iili.io/2nIk1s.md.png",
    origin: "Dhaka",
    Destination: "Cox's Bazar"
},

    {
    id: 2,
    category: "coxbazar",
    name: "Apartment in lost Panorama",
    capacity: "4 guests 2 bedrooms 2 beds 2 baths",
    shortDescription: "Wilf Air Condition Kitchen",
    facility: "Cancellation flexibility available",
    stars: "4.8(10)",
    price: 52,
    totalPrice: "167 total",
    details: "Cox's Bazar is a city, fishing port, tourism center and district headquarters in southern Bangladesh. It is famous mostly for its long natural sandy beach and its...",
    photo: "https://iili.io/2nIeBn.md.png",
    origin: "Dhaka",
    Destination: "Cox's Bazar"
},
    {
    id: 3,
    category: "coxbazar",
    name: "AR Lounge and Pool (r&r + b&b)",
    capacity: "4 guests 2 bedrooms 2 beds 2 baths",
    shortDescription: "Wif Air Condition Kitchen",
    facility: "Cancellation flexibility available",
    stars: "4.9(25)",
    price: 44,
    totalPrice: "167 total",
    details: "Cox's Bazar is a city, fishing port, tourism center and district headquarters in southern Bangladesh. It is famous mostly for its long natural sandy beach and its...",
    photo: "https://iili.io/2nIS2f.md.png",
    origin: "Dhaka",
    Destination: "Cox's Bazar"
},
]
export default coxbazarDetails;